module.exports = __webpack_public_path__ + "static/media/4.0064e52a.webp";